import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetDeliverys, actionGetActiveOrderForDelivery, actionGetOrderHistoryForDelivery } from "../actions/DeliveryBoyActions"
// import { actionGetRestaurants } from "../actions/RestaurantActions"
import { LOGIN_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  Chip,
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import DetailIcon from '@material-ui/icons/Description';
import HistoryIcon from '@material-ui/icons/FormatListNumbered';
import Util, { SUCCESS,ERROR } from '../common/Util'
import Roles from "../config/RolesConstants"
import DeliveryDetailDialog from "./deliverys/DeliveryDetailDialog"
import DeliveryHistoryDialog from "./deliverys/DeliveryHistoryDialog"

class DeliveryBoys extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, deliverys:[], filter:"", detailOpen:false, 
                historyOpen:false, deliveryselected:null, orderInTrip:null, isSuperAdmin:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onClose=this.onClose.bind(this)
  }

  componentWillMount(){
    if(this.props.login){
      // this.props.actionGetRoles(null, (e)=>{console.log("ERROR AL LISTAR ROLES",e)})
      let isSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})>=0)
      let isDelivery = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.DELIVERY})>=0)
      let filter = null
      this.setState({isSuperAdmin:isSuperAdmin, isDelivery:isDelivery})
      if(!isSuperAdmin){
        if(isDelivery){
          filter = {id:this.props.profile.id}
        }else{
          filter = {restoId:this.props.profile.proRestoId}
        }
      }
      this.props.actionGetDeliverys(filter,this.onChangePage, this.getDeliverysError)

    }
  }

  getDeliverysError(e){
    console.log("ERROR GET DELIVERYS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los delivery boys.")
  }

  onSearch(evt){
    this.setState({filter:evt.target.value}, this.onChangePage)
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let deliveryFilter = this.state.filter
    let deliverys = []
    if(this.state.isSuperAdmin){
      let filter = new RegExp(deliveryFilter,"ig")
      deliverys = this.props.deliveryBoyList.filter((d)=>{return d.profile.proName&&d.profile.proName.match(filter)||d.profile.proLastName&&d.profile.proLastName.match(filter)||d.profile.proEmail&&d.profile.proEmail.match(filter)})
    }else{
      deliverys = this.props.deliveryBoyList.filter((d)=>{return d.profile.proEmail&&d.profile.proEmail==deliveryFilter})
    }
    const count = deliverys.length
    deliverys = deliverys.slice(from, end)
    console.log("ON CHANGE PAGE", this.props.deliveryBoyList, deliverys, count)
    this.setState({page:newPage, count:count, deliverys:deliverys})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let deliveryFilter = this.state.filter
    let deliverys = []
    if(this.state.isSuperAdmin){
      let filter = new RegExp(deliveryFilter,"ig")
      deliverys = this.props.deliveryBoyList.filter((d)=>{return d.profile.proName&&d.profile.proName.match(filter)||d.profile.proLastName&&d.profile.proLastName.match(filter)||d.profile.proEmail&&d.profile.proEmail.match(filter)})
    }else{
      deliverys = this.props.deliveryBoyList.filter((d)=>{return d.profile.proEmail&&d.profile.proEmail==deliveryFilter})
    }
    const count = deliverys.length
    deliverys = deliverys.slice(from, end)
    this.setState({rowPerPage:evt.target.value, deliverys:deliverys})
  }

  onDetail(delivery){
    this.props.actionGetActiveOrderForDelivery(
        delivery.id
      , (orders)=>{
          if(orders&&orders.length>0){
            this.setState({deliverySelected:delivery, detailOpen:true, orderInTrip:orders[0]})
          }else{
            Util.notyError("No encontramos el pedido en viaje")
          }
        }
      , ()=>Util.notyError("No encontramos el pedido en viaje")
    )
  }

  onHistory(delivery){
    this.props.actionGetOrderHistoryForDelivery(delivery.id, (orders)=>
      this.setState({deliverySelected:delivery, historyOpen:true, orderHistory:orders})
    ,
      ()=>Util.notyError("No encontramos una orden activa")
    )

    console.log("VER HISTORICO")
  }

  onClose(){
    this.setState({deliverySelected:null, historyOpen:false, detailOpen:false, orderInTrip:false, orderHistory:false})
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Delivery","Apellido y Nombre", "Comercios", "¿En viaje?", "Status"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let deliverys = this.state.deliverys
    if(!deliverys||deliverys.length==0){
      let emptyText="No se encontraron registros"
      if(!this.state.isSuperAdmin){
        emptyText=this.state.filter?`No se encontraron registros para ${this.state.filter}`:"Debe ingresar el email para buscar el delivery"
      }
      return <Box style={theme.table.empty}>{emptyText}</Box>
    }
    return deliverys.map((item, index)=>{
      let isActive=item.active
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.profile.proEmail}</TableCell>
          <TableCell>{`${item.profile.proLastName}, ${item.profile.proName}`}</TableCell>
          <TableCell>{item.restaurants&&item.restaurants.map((r)=>{
            return <Chip label={r.evtTitle} color="primary"/>
          })}</TableCell>
          <TableCell>{item.isInTripNow?"SI":"NO"}</TableCell>
          <TableCell style={isActive?theme.overrides.MuiTableCell.body:theme.table.activeCell}>{isActive?"ACTIVO":"INACTIVO"}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title={"Pedido en viaje"}>
              <IconButton onClick={this.onDetail.bind(this, item)} disabled={!item.isInTripNow}>
                {<DetailIcon/>}
              </IconButton>
            </Tooltip>
            <Tooltip title={"Histórico"}>
              <IconButton onClick={this.onHistory.bind(this, item)}>
                {<HistoryIcon/>}
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, deliveryBoyList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Delivery Boys</Typography>
          <Typography variant="subtitle1">Consulta Delivery Boys</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de deliverys</Typography>
            <Toolbar style={{...theme.table.toolbar, justifyContent:"flex-end"}} >
                <Input placeholder="Buscar" onChange={this.onSearch}/>
            </Toolbar>
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <DeliveryDetailDialog open={this.state.detailOpen} onClose={this.onClose} delivery={this.state.deliverySelected} order={this.state.orderInTrip} theme={theme}/>
          <DeliveryHistoryDialog open={this.state.historyOpen} onClose={this.onClose} delivery={this.state.deliverySelected} orders={this.state.orderHistory} theme={theme}/>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    deliveryBoyList: store.dvy.deliveryBoyList,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetDeliverys,
      actionGetActiveOrderForDelivery,
      actionGetOrderHistoryForDelivery
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(DeliveryBoys)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/DeliveryBoys.js